// extracted by mini-css-extract-plugin
module.exports = {"actions":"student-actions_actions__ol8Gu"};